import { PayloadAction, createSlice, createSelector } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"

export type CommunicatorContact = {
  jid: string
  name: string
}

type Jid = string
type Name = string

type CommunicatorContactsState = Record<Jid, Name>

const initialState: CommunicatorContactsState = {}

type UpsertContactAction = {
  contact: CommunicatorContact
}

export const communicatorContactsSlice = createSlice({
  name: "communicatorContacts",
  initialState,
  reducers: {
    upsertContact: (state, action: PayloadAction<UpsertContactAction>) => {
      state[action.payload.contact.jid] = action.payload.contact.name
    },
    removeContact: (state, action: PayloadAction<string>) => {
      delete state[action.payload]
    },

    modifyContact: (
      state,
      action: PayloadAction<{
        type: "create" | "retract"
        jid: string
        name: string | undefined
      }>,
    ) => {
      const { type, jid, name } = action.payload
      if (type === "create") {
        state[jid] = name ?? jid
      } else {
        delete state[jid]
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { upsertContact, removeContact, modifyContact } =
  communicatorContactsSlice.actions

export default communicatorContactsSlice.reducer
